import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

interface PhoneInputProps {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isInvalid?: boolean;
    config: {
        placeholder: string;
        className: string;
        ariaDescribedby: string;
    };
    translate: (key: string) => string;
    required?: boolean;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange, isInvalid = false, config, translate, required }) => {
    const [maxLength, setMaxLength] = useState<number>(16);
    const formatPhone = (input: string): string => {
        const numbers = input.replace(/\D/g, "");

        if (numbers.startsWith("0800") || numbers.startsWith("0300") || numbers.startsWith("0500")) {
            setMaxLength(13);
            return `${numbers.slice(0, 4)}-${numbers.slice(4, 7)}-${numbers.slice(7, 11)}`.trim();
        } else if (numbers.startsWith("4004")) {
            setMaxLength(9);
            return `${numbers.slice(0, 4)}-${numbers.slice(4, 8)}`.trim();
        } else if (numbers.length <= 2) {
            return `${numbers}`;
        } else if (numbers.length <= 6) {
            return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
        } else if (numbers.length <= 10) {
            return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
        } else {
            setMaxLength(16);
            return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
        }
    };

    const [phone, setPhone] = useState<string>(value || "");

    useEffect(() => {
        setPhone(formatPhone(value));
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const rawValue = e.target.value.replace(/\D/g, "");
        setPhone(e.target.value);
        onChange({ target: { value: rawValue } } as React.ChangeEvent<HTMLInputElement>);
    };

    return (
        <Form.Control
            type="text"
            value={phone}
            onChange={handleChange}
            placeholder={translate(config.placeholder)}
            maxLength={maxLength}
            className={`${config.className} mb-2`}
            autoComplete="off"
            aria-describedby={translate(config.ariaDescribedby)}
            isInvalid={isInvalid}
            required={required}
        />
    );
};

export default PhoneInput;
